import { render, staticRenderFns } from "./ManageCourseForm.vue?vue&type=template&id=24e350b8&scoped=true&"
import script from "./ManageCourseForm.vue?vue&type=script&lang=js&"
export * from "./ManageCourseForm.vue?vue&type=script&lang=js&"
import style0 from "./ManageCourseForm.vue?vue&type=style&index=0&id=24e350b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e350b8",
  null
  
)

export default component.exports